












































































































































































interface BaseDropzoneFileConfig {
  content: File;
  toUpdate?: boolean;
  toDelete?: boolean;
  disableUpdate?: boolean;
  disableDelete?: boolean;
}
import Vue from "vue";
export default Vue.extend({
  props: {
    value: {
      type: [Object as () => BaseDropzoneFileConfig, Array as () => any, File],
      required: false,
    },
    small: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array as () => any[],
    },
    label: {
      type: String,
      required: false,
    },
    name: {
      type: String,
    },
    textWrapped: {
      type: Boolean,
      required: false
    },
    onlyOne: {
      type: Boolean,
      required: false,
    }
  },
  data(): any {
    return {
      multiple: this.value instanceof Array,
      // fakeFiles: [new File([], "fakeFile")],
      data: undefined,
      dragover: false,
    };
  },
  created() {
    this.loadValue();
  },
  computed: {
    empty(): boolean {
      return (
        (!this.multiple && !(this.data?.content || this.data instanceof File)) ||
        (this.multiple && this.data?.length == 0)
      );
    },
    fakeFiles: {
      get(): any {
        return this.data ? [new File([], "fakeFile")] : undefined;
      },
      set() {
        /*ignore*/
      },
    },
  },
  methods: {
    loadValue() {
      this.data =
        this.value instanceof Array
          ? (this.value as any).map((file: any) =>
              this.isBaseFile(file) ? file : Object.assign({ toDelete: undefined, toUpdate: undefined }, file)
            )
          : this.isBaseFile(this.value)
          ? this.value
          : Object.assign({ toDelete: undefined, toUpdate: undefined }, this.value);
    },
    addFilesModal() {
      if (!this.data?.disableUpdate) {
        this.$refs.addFilesModal.$refs.input.click();
      }
    },
    updateFileModal(index: any) {
      if (this.data && this.data[index].content instanceof File && !this.data[index]?.disableUpdate) {
        this.$refs.updateFileModal[index].$refs.input.click();
      }
    },
    isBaseFile(file: any): boolean {
      return file instanceof File || !file;
    },
    onDrop(event: any): any {
      event.preventDefault();
      this.addFiles(event.dataTransfer.files);
    },
    enableDragover(): any {
      this.dragover = true;
    },
    disableDragover(): any {
      this.dragover = false;
    },
    addFiles(newFiles: any[]): any {
      if (!this.disabled) {
        if (this.multiple) {
          this.data = [...this.data, ...newFiles];
          this.$emit("add", newFiles);
        } else {
          if (this.isBaseFile(this.data)) {
            this.data = newFiles[0];
            this.$emit("add", newFiles[0]);
          } else {
            this.updateFile(newFiles[0]);
          }
        }
        this.refresh();
      }
    },
    updateFile(newFile: File, index?: any): any {
      if (!this.disabled) {
        if (this.multiple) {
          if (!this.data[index!].disableUpdate) {
            this.data[index!].content = newFile;
            this.data[index!].toUpdate = true;
            this.$emit("change", { index: index, file: this.data[index!] });
          }
        } else {
          if (!this.data.disableUpdate) {
            this.data.content = newFile;
            this.data.toUpdate = true;
            this.$emit("change", this.data);
          }
        }
      }
    },
    removeFiles(index?: any): any {
      if (!this.disabled) {
        if (this.multiple) {
          if (this.data[index!].content) {
            this.data[index!].toDelete = !this.data[index!].toDelete;
            this.$emit("change", { index: index, file: this.data[index!] });
          } else {
            this.data.splice(index!, 1);
            this.$emit("delete", index);
          }
        } else {
          if (this.data.content) {
            this.data.toDelete = !this.data.toDelete;
            this.$emit("change", this.data);
          } else {
            this.data = undefined;
            this.$emit("delete");
          }
        }
        this.refresh();
      }
    },
    refresh(): any {
      this.dragover = false;
      this.$emit("input", this.data);
    },
  },
  watch: {
    value: {
      handler() {
        this.loadValue();
      },
    },
  },
});
